export function convertBytesToMB(bytes: number, decimalPlaces = 0): number {
	try {
		if (bytes === 0) return 0;
		const mb = bytes / (1024 * 1024);
		return parseFloat(mb.toFixed(decimalPlaces));
	} catch (error) {
		return 0;
	}
}